// removed by extract-text-webpack-plugin
module.exports = {"icon":"a4_a4"};


//////////////////
// WEBPACK FOOTER
// ./elements/icon/style.css
// module id = OrX5
// module chunks = 7